import {
  ADMIN_SCORE_FETCH_ALL,
  ADMIN_SCORE_FETCH_ALL_SUCCESS,
  ADMIN_SCORE_FETCH_ALL_FAIL,
  ADMIN_SCORE_UPDATE,
  ADMIN_SCORE_UPDATE_SUCCESS,
  ADMIN_SCORE_UPDATE_FAIL,
  ADMIN_SCORE_SET_SORT,
  ADMIN_SCORE_FETCH,
  ADMIN_SCORE_FETCH_SUCCESS,
  ADMIN_SCORE_FETCH_FAIL
} from './constants';

export const fetchScores = () => ({
  type: ADMIN_SCORE_FETCH_ALL
});
export const fetchScoresSuccess = scores => ({
  type: ADMIN_SCORE_FETCH_ALL_SUCCESS, scores
});
export const fetchScoresFail = error => ({
  type: ADMIN_SCORE_FETCH_ALL_FAIL, error
});
export const fetchScore = scoreId => ({
  type: ADMIN_SCORE_FETCH, scoreId
});
export const fetchScoreSuccess = score => ({
  type: ADMIN_SCORE_FETCH_SUCCESS, score
});
export const fetchScoreFail = error => ({
  type: ADMIN_SCORE_FETCH_FAIL, error
});
export const updateScore = score => ({
  type: ADMIN_SCORE_UPDATE, score
});
export const updateScoreSuccess = score => ({
  type: ADMIN_SCORE_UPDATE_SUCCESS, score
});
export const updateScoreFail = (error, score) => ({
  type: ADMIN_SCORE_UPDATE_FAIL, error, score
});
export const setAdminScoreSort = sort => ({
  type: ADMIN_SCORE_SET_SORT, sort
});
